import { createSelector } from 'reselect';

const getKycStatus = (state) => state.kycStatus.kycStatus;
const getKycStatusAttempting = (state) => state.kycStatus.attempting;
const getKycStatusError = (state) => state.kycStatus.errorCode;

export const getKycStatusSelector = createSelector(getKycStatus, (kycStatus) => kycStatus);
export const getKycStatusAttemptingSelector = createSelector(getKycStatusAttempting, (attempting) => attempting);
export const getKycStatusErrorSelector = createSelector(getKycStatusError, (errorCode) => errorCode);
